import { defaultUnitDuration } from "@/helper/date/constants/duration.const";
import { UnitDuration } from "@/helper/date/types/duration-options.type";

export const formatDistanceLocale = (unitDisplay?: Partial<UnitDuration>): Record<string, string> => {
  const units = { ...defaultUnitDuration, ...unitDisplay };
  return {
    xSeconds: `{{count}}${units.seconds}`,
    xMinutes: `{{count}}${units.minutes}`,
    xHours: `{{count}}${units.hours}`,
    xDays: `{{count}}${units.days}`,
    xWeeks: `{{count}}${units.weeks}`,
    xMonths: `{{count}}${units.months}`,
    xYears: `{{count}}${units.years}`,
  };
};
